<template>
  <div class="displayFlexSCRW">
    <span>©&nbsp;2019-{{ year }} {{ isCrypto ? 'Trade-Desk' : '' }}.o4biz.ru</span>
    <div>
      <a v-if="0">Конфиденциальность</a>
      <a v-if="0">Условия</a>
    </div>
  </div>
</template>

<script>
import moment from "moment";

export default {
  name: "CopyrightView",
  data: () => {
    return {
      year: moment().format('YYYY')
    }
  },
  computed: {
    isCrypto() {
      return process.env.pack == 'crypto'
    }
  },
};
</script>